var winWidth = $(window).width(),
  winHeight = $(window).height();

$(document).ready(function () {
  bindPopupEve();
  initTabs();
  initAccor();
  initPhotoSwipe();
  initVideoPLayer();
  imageUpload();
  loadPDFDisplayer();
  initSticky();
  jsValidate();
  gallerySpace();
  initMsgClose();
  initLazyLoading();
});

$(window).on('load', function () {
  // Do after Page ready
  ChangeToSvg();
  removeLoader();
  initSticky();
});

$(window).on('resize orientationchange', function () {
  // Do on resize
  winDimensions();
  initSticky();
  // if(winWidth != $(window).width()){
  // }
});

$(window).on('scroll', function () {
  // Do on Scroll
});

$(document).keyup(function (e) {
  if (e.keyCode == 27) { // escape key maps to keycode `27`
    closePopup();
  }
});

function ChangeToSvg() {
  jQuery('img.tosvg').each(function () {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    jQuery.get(imgURL, function (data) {
      var $svg = jQuery(data).find('svg');
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }
      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');
      // Check if the viewport is set, else we gonna set it if we can.
      if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
      }
      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });
}

function winDimensions() {
  winWidth = $(window).width(),
    winHeight = $(window).height();
}

function bindPopupEve() {
  // Popup Open
  $('.js-popup-link').click(function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    var pdfSrc = $(this).attr('data-pdf');
    var iframeLink = $(this).attr('data-iframe');
    openPopup(target, pdfSrc, iframeLink);
  });

  // Popup Close
  $('.js-close-popup:not(.js-close-binded)').click(function (e) {
    e.preventDefault();
    closePopup();
  }).addClass('js-close-binded');

  $('.js-img-popup').click(function (e) {
    e.preventDefault();
    var targetImg = $(this).html();
  });
}

function loadPDFDisplayer() {
  // if($('[data-pdf]').get(0)){
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.onload = function () {
    // remote script has loaded
  };
  script.src = 'assets/js/pdf-display.min.js';
  // document.getElementsByTagName('body')[0].appendChild(script);
  // }
}

var openPopupTarget;
var beforePopupScrollPos;

function openPopup(target, pdfSrc, iframeLink) {
  openPopupTarget = target;
  if (pdfSrc) {
    // We need to delay opening until all HTML is loaded.
    setTimeout(function () {
      DEFAULT_URL = pdfSrc;
      PDFViewerApplication.animationStartedPromise.then(function () {
        PDFViewerApplication.open({
          url: DEFAULT_URL,
        });
      });
    }, 1000);
    // $(target).find('.pdf-wrapper').html('<iframe src="'+pdfSrc+'#zoom=100" height="100%" width="100%"></iframe>');
  }
  if(iframeLink) {
    var iframe = document.createElement('iframe');
    // iframe.style.display = "none";
    iframe.src = iframeLink;
    $(target).find('.iframe-wrap').html(iframe);
  }
  if ($(target).closest('.c-popup').hasClass('inline-popup')) {
    beforePopupScrollPos = window.scrollY;
    $('html').addClass('inline-popup-opening-animation');
    setTimeout(function () {
      $('html').addClass('show-inline-popup');
      window.scrollTo(0, 0);
      openPopupOpening(openPopupTarget);
      $('html').removeClass('inline-popup-opening-animation');
    }, 360);
  } else {
    openPopupOpening(target);
  }
}

function openPopupOpening(target) {
  $('html').addClass('popup-is-active');
  $(target).show();
  $(target).closest('.c-popup').show();
  setTimeout(function () {
    $(target).addClass('active');
    $(target).closest('.c-popup').addClass('popup--open');
    if ($(target).find('.plyr').length) {
      var videoInstance = $(target).find('.plyr').attr('data-video-instance');
      players[videoInstance].play();
    }
    if ($(target).hasClass('popup--video-screen')) {
      $('iframe', target)[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }, 10);


  $('html').addClass('popup-is-active');
  $(target).show();
  $(target).closest('.c-popup').show();
  setTimeout(function () {
    $(target).addClass('active');
    $(target).closest('.c-popup').addClass('popup--open');

    // Play Video
    if (winWidth > 1024 && $(target).find('.plyr').length) {
      var videoInstance = $(target).find('.js-video').attr('data-video-instance');
      if (players[videoInstance]) {
        players[videoInstance].play();
      }
    } else if ($(target).find('.js-video').length) {
      $('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }, 10);
}

function closePopup() {
  if ($('.c-popup .active').length) {
    if ($('.c-popup .active').closest('.c-popup').hasClass('inline-popup')) {
      closingPopup();
      if (typeof (PDFViewerApplication) !== "undefined") {
        PDFViewerApplication.close();
        document.getElementById('title').textContent = '';
      }
      $('html').addClass('inline-popup-close-animation');
      setTimeout(function () {
        $('html').removeClass('show-inline-popup');
        window.scrollTo(0, beforePopupScrollPos);
        $('html').removeClass('inline-popup-close-animation');
      }, 310);
    } else {
      closingPopup();
    }
  }
}

function closingPopup() {
  // Pause Video In Popup
  // if(winWidth > 1024 && $('.c-popup .active .plyr').length){
  //     var videoInstance = $('.c-popup .active .plyr').attr('data-video-instance');
  //     if(players[videoInstance]){
  //         players[videoInstance].pause();
  //     }
  // }else if($('.c-popup .active .js-video').length){
  //     $('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  // }
  if ($('.c-popup .active').hasClass('popup--video-screen')) {
    $('.c-popup .active iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }

  // Close Popup
  $('.c-popup .active').removeClass('active');
  $('.c-popup').removeClass('popup--open');
  setTimeout(function () {
    $('.c-popup .popup').hide();
    $('.c-popup').hide();
    $('html').removeClass('popup-is-active');
  }, 310);
}

function initPhotoSwipe() {
  if ($('.c-img-gallery').get(0)) {
    var initPhotoSwipeFromDOM = function (gallerySelector) {

      // parse slide data (url, title, size ...) from DOM elements 
      // (children of gallerySelector)
      var parseThumbnailElements = function (el) {
        var thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          linkEl,
          size,
          item;

        for (var i = 0; i < numNodes; i++) {

          figureEl = thumbElements[i]; // <figure> element

          // include only element nodes 
          if (figureEl.nodeType !== 1) {
            continue;
          }

          linkEl = figureEl.children[0]; // <a> element

          size = linkEl.getAttribute('data-size').split('x');

          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
          };



          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
          }

          item.el = figureEl; // save link to element for getThumbBoundsFn
          items.push(item);
        }

        return items;
      };

      // find nearest parent element
      var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      };

      // triggers when user clicks on thumbnail
      var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function (el) {
          return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if (!clickedListItem) {
          return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
          childNodes = clickedListItem.parentNode.childNodes,
          numChildNodes = childNodes.length,
          nodeIndex = 0,
          index;

        for (var i = 0; i < numChildNodes; i++) {
          if (childNodes[i].nodeType !== 1) {
            continue;
          }

          if (childNodes[i] === clickedListItem) {
            index = nodeIndex;
            break;
          }
          nodeIndex++;
        }



        if (index >= 0) {
          // open PhotoSwipe if valid index found
          openPhotoSwipe(index, clickedGallery);
        }
        return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
          params = {};

        if (hash.length < 5) {
          return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
          if (!vars[i]) {
            continue;
          }
          var pair = vars[i].split('=');
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }

        if (params.gid) {
          params.gid = parseInt(params.gid, 10);
        }

        return params;
      };

      var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
          gallery,
          options,
          items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

          // define gallery index (for URL)
          galleryUID: galleryElement.getAttribute('data-pswp-uid'),

          getThumbBoundsFn: function (index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();

            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          },
        };

        // PhotoSwipe opened from URL
        if (fromURL) {
          if (options.galleryPIDs) {
            // parse real index when custom PIDs are used 
            // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
            for (var j = 0; j < items.length; j++) {
              if (items[j].pid == index) {
                options.index = j;
                break;
              }
            }
          } else {
            // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
          }
        } else {
          options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
          return;
        }

        if (disableAnimation) {
          options.showAnimationDuration = 0;
        }
        options.showHideOpacity = true;

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      };

      // loop through all gallery elements and bind events
      var galleryElements = document.querySelectorAll(gallerySelector);

      for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      var hashData = photoswipeParseHash();
      if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
      }
    };

    // execute above function
    initPhotoSwipeFromDOM('.c-img-gallery');
  }
}

function initTabs() {
  $('.js-tab-link:not(.js-link-binded)').click(function (e) {
    e.preventDefault();
    var target = $(this).attr('href');

    // Deactivate others
    $('.js-tab-link').removeClass('is--active');
    $('.js-tab-content').removeClass('is--active');

    // Activate the tab
    $(this).addClass('is--active');
    $(target).addClass('is--active');
  }).addClass('js-link-binded');
}

function initAccor() {
  $('.js-accor-link:not(.js-link-binded)').click(function (e) {
    e.preventDefault();
    var target = $(this).attr('href');

    // Deactivate others
    // $('.js-accor-link').removeClass('is--active');
    // $('.js-accor-content').removeClass('is--active');

    // Activate the accor
    if ($(this).hasClass('is--active')) {
      $(this).removeClass('is--active');
      $(target).removeClass('is--active');
      $(target).stop().slideUp();
    } else {
      $(this).addClass('is--active');
      $(target).addClass('is--active');
      $(target).stop().slideDown();
    }
  }).addClass('js-link-binded');
}

function removeLoader() {
  $('body').removeClass('is-loading');
}

function initVideoPLayer() {
  $('.js-video').click(function (e) {
    e.preventDefault();
    $(this).addClass('video--playing');
    $('iframe', this)[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  });
}

var imageUploading = false;

function imageUpload() {
  $('.js-upload-img').click(function (e) {
    if (imageUploading) {
      e.preventDefault();
    } else {}
  });
  $('.js-upload-img').parent().find('input').on('change', function () {
    $(this).parent().find('.js-upload-img').addClass('is-loading');
  });
}

function initSticky() {
  $('.js-sticky-div').each(function () {
    $(this).next().css('height', 0);
    var thisHeight = $(this).height();
    $(this).next().css('height', thisHeight + 20);
  });
}

function jsValidate() {
  $('.js-validate-form').find('[required]').on('change paste keyup', function () {
    validateThis(this);
  });
  $('.js-submit').click(function (e) {
    e.preventDefault();
    $(this).closest('.js-validate-form').find('[required]').each(function () {
      validateThis(this);
    })
  });
}

function validateThis(target) {
  if (!$(target).val()) {
    $(target).addClass('has--error');
  } else {
    $(target).removeClass('has--error');
  }
}


// $('a:not([itemprop="contentUrl"]):not(.js-popup-link)').click(function(){
//     if(!$(this).closest('.popup-wrap').get(0)){
//         $('body').addClass('is-loading');
//     }
// });

















function addVideoPlugin() {
  if (winWidth > 1024 && $('.js-video').get(0)) {
    var plyrScriptElement = document.createElement("script");
    plyrScriptElement.setAttribute('src', 'assets/js/plyr.min.js');

    plyrScriptElement.setAttribute('async', 'true');
    document.body.appendChild(plyrScriptElement);
  } else {
    jsVideoDirect();
  }
}

var players = [];

function jsVideo() {
  // Custom player
  if ($('.js-video').length) {
    $('.js-video').each(function (i) {
      var thisParent = $(this).parent();
      players[i] = new Plyr(this, {
        playsinline: true,
      });
      thisParent.find('.plyr').attr('data-video-instance', i);
    });
  }
}

function jsVideoDirect() {
  if ($('.js-video').length) {
    $('.js-video').each(function (i) {
      $(this).attr('data-video-instance', i);
      var videoId = $(this).attr('data-plyr-embed-id');
      $(this).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + videoId + '?rel=0&playsinline=1&enablejsapi=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
    });
  }
}

function gallerySpace() {
  var uploaderHeight = $('.c-img-uploader').outerHeight(true);
  $('.c-img-gallery').css('margin-bottom', uploaderHeight) + 'px';
}

// Words Limit
(function() {
  $(".js-words-lim").each(function(){
    var $msgElem = $(this).parent().find('.rem-char-msg.msg--count');
    $(this).simplyCountable({
      counter: $msgElem,
      countType: 'words',
      maxCount: 150,
      strictMax: true,
      safeClass: 'is--safe',
      overClass: 'is--over',
      countDirection: 'up',
    });
  });
  
  /*$(".js-words-lim").each(function () {
    $(this).on("change paste keyup", function (event) {
        var key = event.keyCode || event.charCode;
        var content = $(this).val(); //content is now the value of the text box
        var words = content.split(/\s+/); //words is an array of words, split by space
        var num_words = words.length; //num_words is the number of words in the array
        var max_limit = 150;
        var $msgElem = $(this).parent().find('.rem-char-msg');
        
        // Exceeding the max limit
        if (num_words > max_limit && !(key == 8 || key == 46)) {
            
            // Making sure content stays in limit:
            var finalVal = '';
            var finalValWordCount = 0;
            var wordEnded = false;
            var lines = content.split('\n');
            
            if(finalValWordCount <= num_words) {
              for(var x = 0; x < lines.length; x++) {
                var thisLineWords = lines[x].split(' ');
                for(var y = 0; y < thisLineWords.length; x++) {
                  if(thisLineWords[y] == ""){
                    finalVal += " ";
                  }else{
                    finalVal += thisLineWords[y];
                    finalValWordCount++;
                  }
                }
              }
            }else{
              return false;
            }

            $(this).val(finalVal);

            // Adding error class and message
            $msgElem.addClass('error');
            $msgElem.text('Max words reached!');

            return false;
        // }else if(num_words == max_limit) {
            
        }else{
            $msgElem.removeClass('error');
            $msgElem.text(num_words + "/" + max_limit);
        }
    });
  }); */
})();


// $('title').html(winWidth + ' x ' + winHeight);

function initMsgAutoClose(){
  $('.js-close-msg:not(.is-fadding)').each(function(){
    var self = this;
    $(this).addClass('is-fadding');
    setTimeout(function(){
      $(self).parent().stop().fadeOut(function(){
        $(self).parent().remove();
      });
    }, 5000);
  });
}
function initMsgClose(){
  $('.js-close-msg').click(function(e){
    e.preventDefault();
    var self = this;
    $(this).addClass('is-fadding');
    $(this).parent().stop().fadeOut(function(){
      $(self).parent().remove();
    });
  });
}

function initLazyLoading() {
  let lazyImages = [...document.querySelectorAll('.img-lazy-load')];
  let inAdvance = 300;

  function lazyLoad() {
    lazyImages.forEach(image => {
      console.log(image.offsetTop, window.innerHeight + window.pageYOffset + inAdvance);
      if (image.getBoundingClientRect().y < window.innerHeight + window.pageYOffset + inAdvance) {
        image.src = image.dataset.src;
        image.onload = () => image.classList.add('loaded');
      }
    });
  }

  lazyLoad();

  window.addEventListener('scroll', _.throttle(lazyLoad, 16));
  window.addEventListener('resize', _.throttle(lazyLoad, 16));
}